export default {
  status: 0,
  data: [
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000092',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 1,
      DIS_ITEM_NM: '김도시락',
      DIS_ITEM_NM_KO: '김도시락',
      DIS_ITEM_NM_EN: 'lunch2',
      DIS_ITEM_NM_JP: 'べんとう2',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000092',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122374830_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5500,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000091',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 4,
      DIS_ITEM_NM: '스팸치킨도시락',
      DIS_ITEM_NM_KO: '스팸치킨도시락',
      DIS_ITEM_NM_EN: 'lunch1',
      DIS_ITEM_NM_JP: 'べんとう1',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000091',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374829',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122374829_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '01,04,09',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000130',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 5,
      DIS_ITEM_NM: '혜자도시락',
      DIS_ITEM_NM_KO: '혜자도시락',
      DIS_ITEM_NM_EN: 'lunch5',
      DIS_ITEM_NM_JP: 'べんとう5',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000130',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376541',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376541_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '01,05,06',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000277',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 6,
      DIS_ITEM_NM: '게 크림 고로케 도시락',
      DIS_ITEM_NM_KO: '게 크림 고로케 도시락',
      DIS_ITEM_NM_EN: 'lunch7',
      DIS_ITEM_NM_JP: 'べんとう7',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000277',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376540',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376540_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 7500,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '03,04,06',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000278',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 7,
      DIS_ITEM_NM: '김 도시락',
      DIS_ITEM_NM_KO: '김 도시락',
      DIS_ITEM_NM_EN: 'lunch8',
      DIS_ITEM_NM_JP: 'べんとう8',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000278',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376539',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376539_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6500,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '02,03,04',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000276',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 8,
      DIS_ITEM_NM: '엄선 흑초 식초돼지 도시락',
      DIS_ITEM_NM_KO: '엄선 흑초 식초돼지 도시락',
      DIS_ITEM_NM_EN: 'lunch6',
      DIS_ITEM_NM_JP: 'べんとう6',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000276',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376536',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376536_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5500,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '03,07,09',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000280',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 9,
      DIS_ITEM_NM: '치킨 커틀릿 도시락',
      DIS_ITEM_NM_KO: '치킨 커틀릿 도시락',
      DIS_ITEM_NM_EN: 'lunch10',
      DIS_ITEM_NM_JP: 'べんとう10',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000280',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376537',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376537_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 8000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '01,03',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000279',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '햄버그 도시락',
      DIS_ITEM_NM_KO: '햄버그 도시락',
      DIS_ITEM_NM_EN: 'lunch9',
      DIS_ITEM_NM_JP: 'べんとう9',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000279',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376538_1_v0001.jpg',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 7000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      DC_ABLE_YN: 'Y',
      ALLERGY_LIST: '03,06',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
  ],
  message: '',
};
